import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import {
  Card,
  Alert,
  Form,
  Input,
  Button,
  message,
  Select,
  Collapse,
  Typography,
  Space,
  Switch,
  Tooltip,
} from 'antd';
import { updateWorkspace, getChannelList } from '../skills/skills_action';
import Validator from 'validator';
import { InfoCircleOutlined } from '@ant-design/icons';

const { Option } = Select;
const { Text } = Typography;

class Feedback extends Component {
  constructor(props) {
    super();
    this.state = {
      feedbacktoChannel: true,
      channelsLoading: false,
      enableInternalFeedback: false,
      feedbackMail: '',
      feedbackChannel: '',
    };
  }

  componentDidMount() {
    if (this.props.channels && this.props.channels.length === 0) {
      this.setState({ channelsLoading: true });
      this.props
        .getChannelList(this.props.match.params.wId)
        .then((res) => this.setState({ channelsLoading: false }));
    }
    if (this.props.workspace.enableInternalFeedback) {
      this.setState({
        enableInternalFeedback: this.props.workspace.enableInternalFeedback,
        feedbackMail: this.props.workspace.customFeedbackemail,
        feedbackChannel: this.props.workspace.customFeedbackChannel,
      });
    }
  }

  onSave = (data) => {
    let validEmail = true,
      validHelpDocsLink = true;
    let d = {};
    if (data.Feedback.Email && data.Feedback.Email.length > 0) {
      if (
        Validator.isEmpty(data.Feedback.Email) ||
        !Validator.isEmail(data.Feedback.Email)
      ) {
        message.error('Enter valid email address');
        validEmail = false;
      } else {
        d.customFeedbackemail = data.Feedback.Email;
      }
    } else {
      d.customFeedbackemail = '';
    }
    //if(data.Feedback.Docs){
    if (data.Feedback.Docs && data.Feedback.Docs.length > 0) {
      if (
        /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/g.test(
          data.Feedback.Docs
        )
      ) {
        d.customHelpDocsLink = data.Feedback.Docs;
      } else {
        message.error('Enter valid url (example : https://www.troopr.ai)');
        validHelpDocsLink = false;
      }
    } else d.customHelpDocsLink = '';

    data.Feedback.Channel
      ? (d.customFeedbackChannel = data.Feedback.Channel)
      : (d.customFeedbackChannel = '');

    if (validEmail && validHelpDocsLink) this.onCustomFeedbackEmailChange(d);
  };

  onCustomFeedbackEmailChange = (data) => {
    this.props
      .updateWorkspace(this.props.match.params.wId, '', data)
      .then((res) => {
        if (res.data.success) message.success('Updated successfully');
        else message.error('Error updating');
      });
  };

  toggleFeedbackMgmt = () => {
    this.setState({
      enableInternalFeedback: !this.state.enableInternalFeedback,
    });
    this.onCustomFeedbackEmailChange({
      enableInternalFeedback: !this.state.enableInternalFeedback,
    });
  };

  onValuesChange = (changedData, allData) => {
    this.setState({
      feedbackMail: allData.Feedback.Email,
      feedbackChannel: allData.Feedback.Channel,
    });
  };

  render() {
    const { workspace, channels } = this.props;
    const trooprDocsDefaultUrl = 'https://docs.troopr.ai/';
    const tooltipIcon = (
      <InfoCircleOutlined
        style={{
          marginLeft: 5,
          color: 'rgba(0, 0, 0, 0.45)',
          fontSize: '14px',
        }}
      />
    );
    return (
      <Card
        title={
          <div>
            <Text>Internal feedback management</Text>
            <Tooltip title='Streamline feedback management for your team.'>
              {tooltipIcon}
            </Tooltip>
          </div>
        }
        key='1'
        extra={
          <Switch
            checked={this.state.enableInternalFeedback}
            onClick={this.toggleFeedbackMgmt}
          />
        }
        bodyStyle={{ padding: '24px 24px 12px 24px' }}
      >
        <Space
          style={{
            paddingBottom: '26px',
          }}
          direction='vertical'
        >
          <Text type='secondary'>
            Collect feedback using
            <strong style={{ color: '#000000d9' }}> "/t feedback" </strong>
            command in any channel or the
            <strong style={{ color: '#000000d9' }}>
              {' '}
              Help and Feedback button{' '}
            </strong>
            in the Troopr app home footer in Slack.
          </Text>
          <Text type='secondary'>
            {this.state.enableInternalFeedback
              ? `Configure where the feedback should be sent (email and/or channel)
            and provide helpful documentation link`
              : `Currently feedback is being sent to the Troopr team`}
            . Learn more{' '}
            <a
              href='https://docs.troopr.ai/configure-internal-feedback-management-for-the-workspace'
              target='_blank'
            >
              here
            </a>
            .
          </Text>
        </Space>
        {this.state.enableInternalFeedback && (
          <Form
            autocomplete='off'
            ref={this.formRef}
            labelCol={{ span: 4 }}
            wrapperCol={{ span: 14 }}
            // name="userProfileForm"
            hideRequiredMark={true}
            initialValues={{
              Feedback: {
                Email: workspace.customFeedbackemail,
                Channel: workspace.customFeedbackChannel || null,
                Docs: workspace.customHelpDocsLink || trooprDocsDefaultUrl,
              },
            }}
            onFinish={this.onSave}
            onValuesChange={this.onValuesChange}
          >
            <Form.Item
              labelAlign='left'
              label='Email'
              name={['Feedback', 'Email']}
              rules={[
                {
                  type: 'email',
                  required: !this.state.feedbackChannel ? true : false,
                  message: 'Email is required',
                },
              ]}
            >
              <Input allowClear placeholder='Enter custom email' />
            </Form.Item>
            <Form.Item
              labelAlign='left'
              label='Channel'
              name={['Feedback', 'Channel']}
              rules={[
                {
                  required: !this.state.feedbackMail ? true : false,
                  message: 'Channel is required',
                },
              ]}
            >
              <Select
                loading={channels.length === 0 || this.state.channelsLoading}
                allowClear
                showSearch
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
                placeholder='Select custom channel'
              >
                {channels.map((channel) => (
                  <Option key={channel.id}>{channel.name}</Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              labelAlign='left'
              label={
                <div>
                  <Text>Help Docs</Text>
                  <Tooltip title='Help docs link will appear in the feedback submission form.'>
                    {tooltipIcon}
                  </Tooltip>
                </div>
              }
              name={[
                'Feedback',
                'Docs',
              ]} /*rules={[{ type:"email", required: true }]}*/
            >
              <Input allowClear placeholder='Enter custom docs link' />
            </Form.Item>
            <Form.Item wrapperCol={{ span: 12 }} shouldUpdate={true}>
              {() => (
                <Button
                  htmlType='submit'
                  disabled={
                    this.formRef &&
                    this.formRef.current &&
                    (!this.formRef.current.isFieldsTouched(true) ||
                      this.formRef.current
                        .getFieldsError()
                        .filter(({ errors }) => errors.length).length)
                  }
                  type='primary'
                >
                  Save
                </Button>
              )}
            </Form.Item>
          </Form>
        )}
      </Card>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    workspace: state.common_reducer.workspace,
    channels: state.skills.channels,
  };
};

export default withRouter(
  connect(mapStateToProps, { updateWorkspace, getChannelList })(Feedback)
);
